module.exports = __webpack_public_path__ + "img/startConfigurationSolitair.0e35e15.webp";